/**
 * Kis külső tároló a „van új verzió” állapothoz: a service worker regisztráció
 * (index.tsx) írja, a PwaStatus komponens useSyncExternalStore-ral olvassa.
 */

type Listener = () => void;

let waitingRegistration: ServiceWorkerRegistration | null = null;
const listeners = new Set<Listener>();

export const swUpdateStore = {
  setWaiting(registration: ServiceWorkerRegistration | null): void {
    waitingRegistration = registration;
    listeners.forEach((listener) => listener());
  },
  getSnapshot(): ServiceWorkerRegistration | null {
    return waitingRegistration;
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

export default swUpdateStore;
